import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import './ret.css';
import FormData from 'form-data';
import dayjs from 'dayjs';
import {he} from './store';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, Link } from 'react-router-dom';

const Indo=(choo)=>{
const solji = useRef(0);

useEffect(()=>{

    solji.current = choo;
},[choo]);
return solji.current;
};

const Wonha =()=>{
    const [Files, setFiles] = useState({info : []});
    const [sna, setsna] = useState(0);
    const [insoo, setinsoo] = useState("");
    const [kakye, setkakye] = useState([]);
    const [peri, setperi] = useState(3);
    const [sigan, setsigan] = useState(0);
    const [kulli, setkulli] = useState(false);
    const [jiral, setjiral] = useState();
    const [screen, setscreen] = useState(false);
    const [ill, setill] = useState({a:"", b : []});
    const [pibot, setpibot] = useState(false);
    const [jolso, setjolso] = useState({a:"",b:"",c:1});
    const [pach, setpach]=useState({a:false,b:""});
    const vangu = useRef();
    const [promo, setpromo] = useState(0);

    const forads = useLocation();
    const yoheng = useNavigate();
    const fale = useSelector(state => state.mahena);
    const dispatch = useDispatch();
    
 
    const admotion = [
        {title : "패키지 A", ny1 : "노출 효과를 기대할 수 있는 탁월한 선택", ny2 : "노출 면접 최대화", gs1 : "대표 상품", gs2 : "돌파메인,돌파추천,리스트탑", gs3 : "kk-pa.png"},
        {title : "패키지 B", ny1 : "메인과 인기의 절묘한 조합", ny2 : "전면을 촘촘히 채우다", gs1 : "인기 상품", gs2 : "돌파메인,돌파스페셜,리스트탑", gs3 : "kk-pb.png"},
        {title : "패키지 C", ny1 : "실속을 책임지는 종합 선택", ny2 : "시선에 잡히는 구성", gs1 : "실속 상품", gs2 : "돌파추천,돌파주목,리스트탑", gs3 : "kk-pc.png"},
        {title : "돌파메인", ny1 : "첫 등장에 노출 올인", ny2 : "확실한 집중을 선택 ", gs1 : "노출 전면", gs2 : "돌파메인", gs3 : "kk-main.png"},
        {title : "돌파추천", ny1 : "인지도를 높이다", ny2 : "중반부에 위치한 공략터", gs1 : "집중 나열", gs2 : "돌파추천", gs3 : "kk-a.png"},
        {title : "돌파스페셜", ny1 : "눈에 띄는 배치", ny2 : "숨고르기 순간을 노리다", gs1 : "관심 집중", gs2 : "돌파스페셜", gs3 : "kk-b.png"},
        {title : "돌파주목", ny1 : "한 번 더 확인하는 효과", ny2 : "차별화 프레임으로 이목을 끌다", gs1 : "관심 유지", gs2 : "돌파주목", gs3 : "kk-c.png"},
        {title : "이벤트배너", ny1 : "이벤트를 위한 창구", ny2 : "만인이 참여하는 오픈창", gs1 : "깜짝 정보", gs2 : "이벤트배너", gs3 : "kk-c.png"},
        {title : "리스트탑", ny1 : "텍스트로 노출하는 상품", ny2 : "목록의 우두머리", gs1 : "목록 시선", gs2 : "리스트탑", gs3 : "kk-l.png"}
    ];
    const jas =(e)=>{
        document.body.style.overflow = 'unset';
        document.body.style.paddingRight = '0px';
        document.querySelector('.suent').classList.remove('suent');
        if(e.target.getAttribute('name') == "first"){
            document.getElementsByName('first')[0].classList.add('suent');
            //e.target.classList.add('seunt');
            document.title = "광고유형선택 - 돌파공모";
            setsna(0);
        }else if(e.target.getAttribute('name') == "second"){
       
           document.getElementsByName('second')[0].classList.add('suent'); 
           document.title = "기업전용첨삭 - 돌파공모";
            setsna(1);
        }else if(e.target.getAttribute('name') == "third"){
       
            document.getElementsByName('third')[0].classList.add('suent'); 
            document.title = "광고안내 - 돌파공모";
            setsna(2);
        };
    };
    useEffect(()=>{},[sna]);
    useEffect(()=>{nasi();   document.title = "광고유형선택 - 돌파공모";},[]);

    const removes=(e)=>{
        e.preventDefault();
      
        const removeTargetId = e.target.dataset.index;
        const removeTarget = document.getElementById(removeTargetId);
    
        const files = document.getElementsByName('info')[0].files;
      
        
        const dataTranster = new DataTransfer();      
        Array.from(files).filter(file => file.lastModified != removeTargetId)
                        .forEach(file => {dataTranster.items.add(file);});
        document.getElementsByName('info')[0].files = dataTranster.files;
    
     
        setFiles({...Files, info : dataTranster.files});
        removeTarget.remove();
    };

    const kulja =(e)=>{
        setkulli(true);
        document.getElementById("zero-v").textContent = "";
        const kulla = document.querySelector('.kulji');
        const suua = document.querySelector('.suuu');
        const beea = document.querySelector('.beei');
        const inuu = document.querySelector('.innum');
        
        kulla.addEventListener('input', ()=>{
            suua.innerText = `${kulla.value.length}자 ` + bytehap(kulla) + `btye`;
            beea.innerText = `${(Math.floor(kulla.value.length / 1000)+1)*40000}원`;
            const pric = (Math.floor(kulla.value.length / 1000)+1)*40000;
            const kpric = Number(pric);
        
           // inuu.value = kpric.toLocaleString('ko-KR');
            inuu.value = kpric
        });
    };
    const pezi=(e)=>{
        setkulli(false);
        const kulla = document.querySelector('.kulji');
        const suua = document.querySelector('.suuu');
        const beea = document.querySelector('.beei');
        let prc;
        if(kulla.value.length == 0){
            prc = 0;
        }else{
            prc = (Math.floor(kulla.value.length / 1000)+1)*40000;
        };
        
        kulla.value = "";
        suua.innerText = "글자수";
        beea.innerText = "비용";
        const uipd = document.querySelector('.innum').value;
   
        setjiral(prc);
    };

    const bytehap=(e)=>{
        let byte = 0;
        for(let i = 0; i < e.value.length; i++){
            if (/[\sa-zA-Z0-9`~!@#$%^&*()_+-={}\[\];':",./<>?]/.test(e.value[i])) {
                byte++;
            }else{
                byte = byte+2;
            };
        };
        return byte;
    };

    const overgo =(e)=>{
        const kama = document.createElement('img');
        
        let sisi = e.pageX - e.offsetX;
        let zizi = e.pageY - e.offsetY;
    
        kama.src = e.target.src;
        kama.className = "marma";
        kama.style.left = sisi+"px";
        kama.style.top = zizi+"px";
        kama.onmouseout = outgo;
        e.target.parentNode.appendChild(kama);
    };

    const outgo =(e)=>{
        e.target.className = "marma bande";
        const mich = setTimeout(() => {
            e.target.remove();
            clearTimeout(mich);
        }, 600);
       // e.target.remove();
    };

    const checkfo =(e)=>{
        const sssing = e.target.id === "ssii" ? "pianm" : "bianm";
    
        document.getElementById(sssing).textContent = "";
        
        const compa =  5*1024*1024;
          
            const prh = document.querySelector('#worksh');
            const files = Array.from(e.target.files);
            for(let f in files){
                if(files[f].size > compa){
                    e.target.value = "";
                    document.getElementById(sssing).textContent = "5MB 이하로 업로드해주세요";
                    return;
                }; 
            };
            files.forEach(file => {
                const parx = document.createElement('p');
                parx.id = file.lastModified;
                const fileNameText = document.createTextNode(file.name + " ");
                parx.appendChild(fileNameText);
                const button = document.createElement('button');
                button.onclick = removes;
                button.dataset.index = file.lastModified;
                button.innerText = "X";
                button.style.margin = "0 5px";
                button.style.height = "24px";
                // parx.innerText = file.name;
                parx.appendChild(button);
                let iama;
                const adm = ["image/jpeg", "image/png"];
                if(adm.includes(file.type)){
                  
                    iama = document.createElement('img');
                    iama.src = URL.createObjectURL(file);
                    iama.className = "wooja";
                    iama.onmouseover = overgo;
                    parx.appendChild(iama);
                };
                prh.appendChild(parx); 
            });
            if(Files.info.length > 0){
             
                const dataTranster = new DataTransfer();      
                Array.from([...Files.info, ...e.target.files]).forEach(file => {dataTranster.items.add(file);});
                document.getElementsByName('info')[0].files = dataTranster.files;
            
                setFiles({...Files, info : [...dataTranster.files]});
            }else{
            setFiles({...Files, info : [...e.target.files]});
            };
        
            };

    const kkk= async (e)=>{    
        e.preventDefault();

        const door = e.target.buta.value;
        const tonight = dayjs().format('YYYY-MM-DD');
        const shot = new FormData();
       
        if(e.target.title.value.trim().length === 0){
            document.getElementById(door === "sug1" ? "zero-title" : "zero-write1").textContent = "필요해요";
            return;
        };
        if(e.target.holder.value.trim().length === 0){
            document.getElementById(door === "sug1" ? "zero-holder" : "zero-write2").textContent = "필요해요";
            return;
        };
        if(e.target.mails.value.trim().length === 0){
            document.getElementById(door === "sug1" ? "zero-mail" : "zero-write3").textContent = "필요해요";
            return;
        };
        shot.append('title', e.target.title.value);
        shot.append('holder',e.target.holder.value);
        let adup;
        if(door == 'sug1'){
            const firs = jolso?.a.slice(0, -1);
            const ends = jolso?.b;
            if(firs.trim().length === 0 || ends.trim().length === 0){
                return;
            };
            shot.append('perio', jolso?.c);
            shot.append('cost', (pach?.b * jolso?.c).toLocaleString('ko-KR') );
            shot.append('start', dayjs(firs).format('YYYY-MM-DD'));
            shot.append('end', dayjs(ends).format('YYYY-MM-DD'));
            shot.append('pick', pach?.a);
            adup = fale.post?.map((a)=>{
                if(a.title == e.target.title.value){
                   return {...a, ad : pach?.a, ads : dayjs(firs).format('YYYY-MM-DD'), ade : dayjs(ends).format('YYYY-MM-DD')};
                }else{
                    return a;
                };
            });
            shot.append('posts', JSON.stringify(adup));
        }else{
            if(e.target.cost.value.trim().length === 0 ){
                document.getElementById("zero-v").textContent = "필요해요";
                return;
            };
            shot.append('perio', e.target.on7.value);
            shot.append('cost', e.target.cost.value);
            shot.append('pick', e.target.suntac.value);
        }
        shot.append('today', tonight);
        shot.append('type', door);
        shot.append('mails', e.target.mails.value);
        shot.append('tels', e.target.tels.value);
        shot.append('story', e.target.story.value);
        if(Files.info.length > 0) {
            Files.info.map((kona,i)=>shot.append('info',kona));
        }else{
            shot.append('info', "");
        };
        const oiu = await axios.post(`/api/suggest/${door}`,shot, {headers: {"Content-Type" : "multipart/form-data"}})
        .then(eah=>{ setsna(4); dispatch(he({...fale, post : adup}));}).catch(err=>{
            if(err.response?.data?.condition === "typenot"){
                alert("요청 분야를 확정해주세요");
            };
            if(err.response?.data?.condition === "nonetitle"){
                document.getElementById(door === "sug1" ? "zero-title" : "zero-write1").textContent = "필요해요";
            };
            if(err.response?.data?.condition === "noneholder"){
                document.getElementById(door === "sug1" ? "zero-holder" : "zero-write2").textContent = "필요해요";
            };
            if(err.response?.data?.condition === "nonemail"){
                document.getElementById(door === "sug1" ? "zero-mail" : "zero-write3").textContent = "필요해요";
            };
            if(err.response?.data?.condition === "nonecost"){
                document.getElementById("zero-v").textContent = "필요해요";
            };
            if(err.response?.data?.success == "overfile"){
                document.getElementById("pianm").textContent = "5MB 이하로 업로드해주세요";
            };
            if(err.response?.data?.success == "overtotal"){
                document.getElementById("pianm").textContent = "업로드 파일은 최대 5개입니다";
            };
        });
    };

    const sootsu=(e)=>{
        const val=e.target.value.replace(/[^\d-]/g, '');
     
        setinsoo(val);
    };
  
    const sumva =(e)=>{
        
        if(["패키지1","패키지2","패키지3","패키지4","패키지5"].includes(e.target.value)){
       
            switch(e.target.value){
                case "패키지1" :
                    setkakye([10000, 20000, 30000, 40000, ""]);
                    break;
                case "패키지2" :
                    setkakye([20000, 30000, 40000, 50000, ""]);
                    break;  
                case "패키지3" :
                    setkakye([8000, 15000, 20000, 24000, ""]);
                    break;
                case "패키지4" :
                    setkakye([5000, 8000, 11000, 14000, ""]);
                    break;
                case "패키지5" :
                    setkakye([1000, 2000, 3000, 4000, ""]);
                    break;              
            }; 
        };
        if(["1주","2주","3주","1달","기타"].includes(e.target.value)){
            switch(e.target.value){
                case "1주" :
                    setperi(0);
                    break;
                case "2주" :
                    setperi(1);
                    break;    
                case "3주" :
                    setperi(2);
                    break;
                case "1달" :
                    setperi(3);
                    break;        
                case "기타" :
                    setperi(4);
                    break;    
            };
        };
    };

    const zumva=(e)=>{
        // if(["공모전","연구계획","프로젝트","사내활동","기타"].includes(e.target.value)){
        //     switch(e.target.value){
                
        //     };
        // };
        if(["24시간","48시간","72시간"].includes(e.target.value)){
            switch(e.target.value){
                case "24시간" :
                    setsigan(40000);
                    break;
                case "48시간" :
                    setsigan(20000);
                    break;    
                case "72시간" :
                    setsigan(0);
                    break;      
            };
        };
    };

    const lupin =(e)=>{
        const lumico = e.target.nextElementSibling;
        if(lumico.textContent.trim() !== ''){
            lumico.textContent = '';
        };
    };
    
    const nasi =()=>{
        // document.querySelector('.newca').classList.replace('newca','newco');
        const today = new Date();
        const mont = today.getMonth()+1;
        let arrayday = [today.getDate()];
        for(let i = 0; i <= 120; i++){
           arrayday.push(new Date(today.setDate(today.getDate() + 1)).getDate());
        };
        setill({a : mont, b : arrayday});
      
    };

    const jiuki=(e)=>{
        setpibot(false);
        document.querySelector(".ibbu").remove();
        const yuyu = document.querySelectorAll(".day1");
        yuyu.forEach((you)=>{
            you.classList.remove("nanan","balga","palga","macka");
        });
        //e.target.removeEventListener("click", jiuki);
        setjolso({a:"",b:"",c:1});
        setpach({a:false,b:""});
        document.querySelector(".ajiko")?.classList.remove("ajiko");
        document.querySelector(".aiai").classList.replace("aiai", "biran");
       
    };

    const selld=(e)=>{
        if(pach.a == false){
            document.querySelector(".pakis").classList.add("hugaz");
            document.querySelector(".hino").classList.remove("nohi");
            return;
        };
        if(pibot == false){
        vangu.current = e.target.getAttribute("num");
        const dayto = new Date();
        const daytos = new Date(dayto.setDate(dayto.getDate() + parseInt(vangu.current)));
        const star1 = daytos.getFullYear()+"."+(daytos.getMonth() < 9 ? "0"+(daytos.getMonth()+1) : daytos.getMonth()+1)+"."
        +(daytos.getDate() < 10 ? "0"+daytos.getDate() : daytos.getDate());
        setjolso({...jolso, a:star1+"~"});
        e.target.classList.add("palga");
        for(let i = 0; i < vangu.current; i++){
            e.target.parentNode.childNodes[i].classList.add("nanan");
        };
        setpibot(true);
        document.querySelector(".biran").classList.replace("biran","aiai");
       
        }else{
            const prevna = vangu.current;
            vangu.current = e.target.getAttribute("num");
            const gapd = parseInt(vangu.current) - parseInt(prevna)+1;
            const dayto = new Date();
            const daytos = new Date(dayto.setDate(dayto.getDate() + parseInt(vangu.current)));
            const star2 = daytos.getFullYear()+"."+(daytos.getMonth() < 9 ? "0"+(daytos.getMonth()+1) : daytos.getMonth()+1)+"."
            +(daytos.getDate() < 10 ? "0"+daytos.getDate() : daytos.getDate());
            if(prevna !== vangu.current){
                document.querySelector(".palga").classList.add("macka");
            };
            const vapa = parseInt(vangu.current)+1;
            e.target.classList.replace("balga","palga");
           // e.target.classList.add("palga");
            // e.target.classList.add("macka");
            // document.querySelector(".palga").classList.add("macka");
            const gae = e.target.parentNode.childNodes;
            for(let i = vapa; i < gae.length; i++){
                e.target.parentNode.childNodes[i].classList.add("nanan");
            };
            const remo = document.querySelectorAll(".balga");
            remo.forEach((each)=>{
                each.classList.add("macka");
            });
          //  const jyu = document.querySelectorAll(".palga");
            
                const poy = document.createElement("span");
                poy.innerHTML = "X"
                poy.className = "ibbu";
                e.target.appendChild(poy);
                poy.addEventListener("click", jiuki);
            setjolso({...jolso, b:star2,c:gapd});
            setpibot(false);
        }; 
    };
    const noeffec =(e)=>{
        e.stopPropagation();
    };
    const sellov=(e)=>{
      
        if(pibot == true){
        const overa = e.target.getAttribute("num"); 
        const remo = parseInt(vangu.current)+1;
  
        for(let i=remo; i<=overa; i++){
            e.target.parentNode.childNodes[i].classList.add("balga");
        };
        };
    };

    const sellut=(e)=>{
        if(pibot == true){
            const remo = document.querySelectorAll(".balga");
            remo.forEach((each)=>{
                each.classList.remove("balga");
            });
        
        };
    };
    
    const voki=(e)=>{
        if(e.target.getAttribute("name") == "pici"){
           
            document.querySelectorAll(".banas")[1].classList.add("maga");
            document.querySelectorAll(".banas")[0].classList.remove("maga");
        }else{
            
            document.querySelectorAll(".banas")[0].classList.add("maga");
            document.querySelectorAll(".banas")[1].classList.remove("maga");
        };
    };

    const collar=(e)=>{
        document.querySelector(".ajiko")?.classList.remove("ajiko");
        document.querySelector(".pakis").classList.remove("hugaz");
        document.querySelector(".hino").classList.add("nohi");
        if(pach.a == e.target.getAttribute("pack")){
        setpach({a: false ,b:""});
     
      //  e.target.parentNode.classList.remove("ajiko");
        }else{
        switch(e.target.getAttribute("pack")){
            case "a" :
                setpach({a: "패키지A", b: 110000});
                break;
            case "b" :
                setpach({a: "패키지B", b: 90000});
                break;    
            case "c" :
                setpach({a: "패키지C", b: 70000});
                break;
            case "d" :
                setpach({a: "돌파메인", b: 80000});
                break;        
            case "e" :
                setpach({a: "돌파추천", b: 60000});
                break;  
            case "f" :
                setpach({a: "돌파스페셜", b: 40000});
                break;
            case "g" :
                setpach({a: "돌파주목", b: 30000});
                break;
            case "h" :
                setpach({a: "이벤트배너", b: 30000});
                break;    
            case "i" :
                setpach({a: "리스트탑", b: 25000});
                break;          
        };
        e.target.parentNode.classList.add("ajiko")
       
        };
    };
    const exap=(e)=>{
     
        setpromo(e.target.getAttribute("value")); 
        const hwamen = document.querySelector(".omoi");
        hwamen.style.display= "block";
        const ingirl = document.querySelector(".amai");
        ingirl.style.display= "block";

        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = `${scrollbarWidth}px`;
    };

 useEffect(()=>{
       
        return () => {
          document.body.style.overflow = 'unset';
          document.body.style.paddingRight = '0px';
        };
      }, []);

    const saraji =(e)=>{
        e.stopPropagation();
        document.querySelector(".omoi").style.display = "none";
        document.querySelector(".amai").style.display = "none";

        document.body.style.overflow = 'unset';
        document.body.style.paddingRight = '0px';
    };
    const saraje=(e)=>{
        e.stopPropagation();
        document.querySelector(".omoi").style.display = "none";
        document.querySelector(".amai").style.display = "none";

        document.body.style.overflow = 'unset';
        document.body.style.paddingRight = '0px';
    };
    let sooha = 0;
    return(
    <>
    {sna == 4 && <div className='pyoji'>
        <p>안내드리겠습니다!</p>
        <Link to="/" style={{textDecoration:"none"}}>메인페이지</Link>
        </div>}
    {sna == 4 ? "" :     
    <div className='keye'>
     <span onClick={jas} name="first" className='keyf suent'>광고유형선택</span>
     <span onClick={jas} name="second" className='keyf'>기업전용첨삭</span>
     <span onClick={jas} name="third" className='keyf'>광고안내</span>
    </div>}
    {sna == 0 &&  <form onSubmit={kkk}>
    <div className='newco'>
      <div className='pakis'>
        <div className='hino nohi'><p className='hina'><span>패키지를 선택하세요</span></p></div>
        <div className='mooks'>
            <span onClick={collar} pack="a" className='mooks1'>패키지 A</span>
            <span onClick={exap} value="0" className='mooks2' style={{backgroundImage: `url(${process.env.PUBLIC_URL}/infm.png)`}}>보기</span>
        </div>
        <div className='mooks'>
            <span onClick={collar} pack="b" className='mooks1'>패키지 B</span>
            <span onClick={exap} value="1" className='mooks2' style={{backgroundImage: `url(${process.env.PUBLIC_URL}/infm.png)`}}>보기</span>
        </div>
        <div className='mooks'>
            <span onClick={collar} pack="c" className='mooks1'>패키지 C</span>
            <span onClick={exap} value="2" className='mooks2' style={{backgroundImage: `url(${process.env.PUBLIC_URL}/infm.png)`}}>보기</span>
        </div>
        <div className='mooks'>
            <span onClick={collar} pack="d" className='mooks1'>돌파메인</span>
            <span onClick={exap} value="3" className='mooks2' style={{backgroundImage: `url(${process.env.PUBLIC_URL}/infm.png)`}}>보기</span>
        </div>
        <div className='mooks'>
            <span onClick={collar} pack="e" className='mooks1'>돌파추천</span>
            <span onClick={exap} value="4" className='mooks2' style={{backgroundImage: `url(${process.env.PUBLIC_URL}/infm.png)`}}>보기</span>
        </div>
        <div className='mooks'>
            <span onClick={collar} pack="f" className='mooks1'>돌파스페셜</span>
            <span onClick={exap} value="5" className='mooks2' style={{backgroundImage: `url(${process.env.PUBLIC_URL}/infm.png)`}}>보기</span>
        </div>
        <div className='mooks'>
            <span onClick={collar} pack="g" className='mooks1'>돌파주목</span>
            <span onClick={exap} value="6" className='mooks2' style={{backgroundImage: `url(${process.env.PUBLIC_URL}/infm.png)`}}>보기</span>
        </div>
        <div className='mooks'>
            <span onClick={collar} pack="h" className='mooks1'>이벤트배너</span>
            <span onClick={exap} value="7" className='mooks2' style={{backgroundImage: `url(${process.env.PUBLIC_URL}/infm.png)`}}>보기</span>
        </div>
        <div className='mooks'>
            <span onClick={collar} pack="i" className='mooks1'>리스트탑</span>
            <span onClick={exap} value="8" className='mooks2' style={{backgroundImage: `url(${process.env.PUBLIC_URL}/infm.png)`}}>보기</span>
        </div>
      </div>
      <div className='iljong'>
        <div className='month1'><span className='month2'>{ill?.a}{' '}월</span></div>
        <div className='week1'>{ill.b.length>0 && ill.b.map((day,i)=>{
            if(day == 1){
                if(i == 0){
                return (<span className='day1' onClick={selld} num={i} onMouseOver={sellov} onMouseOut={sellut}><span className='daymon' onClick={noeffec}>{ill?.a+sooha}</span><span className='slar' onClick={noeffec}>/</span>{day}</span>)    
                }else{
                    sooha++;
                    if(ill?.a+sooha > 12){
                        return (<span className='day1' onClick={selld} num={i} onMouseOver={sellov} onMouseOut={sellut}><span className='daymon' onClick={noeffec}>{ill?.a+sooha-12}</span><span className='slar' onClick={noeffec}>/</span>{day}</span>)
                    }else{
                        return (<span className='day1' onClick={selld} num={i} onMouseOver={sellov} onMouseOut={sellut}><span className='daymon' onClick={noeffec}>{ill?.a+sooha}</span><span className='slar' onClick={noeffec}>/</span>{day}</span>)        
                    }
                }
            }else{return (
            <span className='day1' onClick={selld} num={i} onMouseOver={sellov} onMouseOut={sellut}>{day}</span>
            )}})
        }</div>
      </div>
      <div className='biyo'>
        <div className='biran'>
        <p>비용</p>
        <p><span>상품</span><span className='leftgo'>{pach?.a}</span></p>
        <p><span>기간</span><span className='leftgo'>{jolso?.c}일</span></p>
        <p><span>{jolso?.a}{jolso?.b}</span></p>
        <p><span>금액</span><span className='leftgo'>{(pach?.b * jolso?.c).toLocaleString('ko-KR') }원</span></p>
        </div>
      </div>
      <div className='omoi' onClick={saraji}>
     
      </div>
      <div className='amai'>
            <div className='pashe'><span onClick={saraje} className='psin'>X</span></div>
            <div>
                <div style={{paddingTop:"40px"}}><span style={{fontSize:"20px"}}>{admotion[promo].title}</span></div>
                <div className='cheo'>
                    <p>{admotion[promo].ny1}</p>
                    <p>{admotion[promo].ny2}</p>
                </div>
            </div>
            <div className='namoi'>
                <div className='ibaek'>
                    <div><p>{admotion[promo].gs1}</p></div>
                    <div><p style={{fontSize:"14px"}}>{admotion[promo].gs2}</p></div>
                </div>
                <div className='sambaek'>
                    <img src={process.env.PUBLIC_URL+'/'+admotion[promo].gs3} alt='manmun' className='adpa'/>
                </div>
            </div>
            <div className='majiro' onClick={jas} name="third">
               
                <div className='majiro-a' name="third">
                    <div className='sambaek' style={{height:"30px"}} name="third"><span className='sami' name="third">광고를 더 알아볼까요?</span></div>
                    <div className='ibaek' name="third"><img src={process.env.PUBLIC_URL+'/chalkboard-m.png'} alt='goto ad' name="third"/></div>
                </div>
                
            </div>
        </div>
    </div>
     <table className='kimid'>
        <tbody>
            {/* <tr>
                <th>광고상품</th><td className='myung'><div>
                    <select onChange={sumva} name='suntac'>
                        <option value="선택">선택</option>
                        <option value="패키지1">패키지1</option>
                        <option value="패키지2">패키지2</option>
                        <option value="패키지3">패키지3</option>
                        <option value="패키지4">패키지4</option>
                        <option value="패키지5">패키지5</option>
                    </select></div></td>
            </tr>
            <tr>
                <th>게재기간</th>
                <td className='ahall'>
                    <div><input type='radio' name='on7' id='ah1' value="1주" onChange={sumva} checked={peri == 0}/><label for='ah1'>1주</label></div>
                    <div><input type='radio' name='on7' id='ah2' value="2주" onChange={sumva} checked={peri == 1}/><label for='ah2'>2주</label></div>
                    <div><input type='radio' name='on7' id='ah3' value="3주" onChange={sumva} checked={peri == 2}/><label for='ah3'>3주</label></div>
                    <div><input type='radio' name='on7' id='ah4' value="1달" onChange={sumva} checked={peri == 3}/><label for='ah4'>1달</label></div>
                    <div><input type='radio' name='on7' id='ah5' value="기타" onChange={sumva} checked={peri == 4}/><label for='ah5'>기타</label>
                    {peri == 4 && <input type='text' placeholder='기간' className='sides' name='chooga'/>}</div>
                </td>
            </tr> */}
            {/* <tr><th>비용</th><td className='suty'><input type='text' name='cost' value={kakye?.length > 0 ? kakye[peri].toLocaleString('ko-KR') : ""} readOnly/><label>만원 (부가세 미포함)</label></td></tr> */}
            <tr><th>공모명</th><td className='myung'><input type='text' name='title' value={forads.state?.posta && forads.state.posta.title } onFocus={lupin} required/><span id="zero-title" className='seocho'></span></td></tr>
            <tr><th>담당자</th><td className='myung'><input type='text' name='holder' value={forads.state?.sinsa && forads.state.sinsa.name } onFocus={lupin} required/><span id="zero-holder" className='seocho'></span></td></tr>
            <tr>
                <th>첨부파일</th>
                <td><div className='honja'>파일선택<input type='file' className='filenm' onChange={checkfo} name='info' title='파일' id='ssii' multiple/></div>
                    <div id="worksh" className='hannjo'><span id="pianm"></span></div>
                </td>
            </tr>
            <tr><th>연락처</th><td className='myung'><input type='text' value={forads.state?.sinsa && forads.state.sinsa.tels } onChange={sootsu} name='tels'/></td></tr>
            <tr><th>이메일</th><td className='myung'><input type='email' name='mails' value={forads.state?.sinsa && forads.state.sinsa.mail } onFocus={lupin} required/><span id="zero-mail" className='seocho'></span></td></tr>
            <tr><th>추가 사항</th><td className='myung'><textarea className='arey' name='story'/></td></tr>
        </tbody>
     </table>   
     <button onSubmit={kkk} value='sug1' name='buta'className='zongyo' >제출</button>
    </form>} 
    {sna == 1 &&
    <form onSubmit={kkk}>
     <table className='kimid'>
        <tbody>
            <tr>
                <th>첨삭대상</th>
                <td className='myung'><div>
                    <select style={{width:"200px"}} onChange={zumva} name='suntac' required>
                        <option value="">선택</option>
                        <option value="공모전">공모전 안내문</option>
                        <option value="연구계획">연구계획서</option>
                        <option value="프로젝트">프로젝트 기획 및 평가서</option>
                        <option value="사내활동">사내 활동(인사고과반영)</option>
                        <option value="기타">기타</option>
                    </select>
                </div></td>
            </tr>
            <tr>
                <th>완료기간</th>
                <td className='ahall adwi'>
                    <div><input type='radio' name='on7' id='ah1' value="24시간" onChange={zumva} checked={sigan == 40000}/><label for='ah1'>24시간</label></div>
                    <div><input type='radio' name='on7' id='ah2' value="48시간" onChange={zumva} checked={sigan == 20000}/><label for='ah2'>48시간</label></div>
                    <div><input type='radio' name='on7' id='ah3' value="72시간" onChange={zumva} checked={sigan == 0}/><label for='ah3'>72시간</label></div>
                </td>
            </tr>
            <tr>
                <th>첨부파일</th>
                <td><div className='honja'>파일선택<input type='file' className='filenm' onChange={checkfo} name='info' title='파일' id='nnii' multiple/></div>
                    <div id="worksh" className='hannjo'><span id="bianm"></span></div>
                </td>
            </tr> 
            <tr><th>비용</th>
            <td className='suty'><input type='text' className='innum' name='cost' value={jiral > 0 ? (parseInt(jiral)+parseInt(sigan)).toLocaleString('ko-KR') : ""} readOnly/><label>원 (부가세 미포함)</label>
            <span onClick={kulja} className='seki'>글자수세기</span><span id="zero-v" className='seocho'></span></td></tr>
            <tr><th>의뢰명</th><td className='myung'><input type='text' name='title' onFocus={lupin} required/><span id="zero-write1" className='seocho'></span></td></tr> 
            <tr><th>의뢰자</th><td className='myung'><input type='text' name='holder' onFocus={lupin} required /><span id="zero-write2" className='seocho'></span></td></tr>
            <tr><th>연락처</th><td className='myung'><input type='text' value={insoo} onChange={sootsu} name='tels'/></td></tr>
            <tr><th>이메일</th><td className='myung'><input type='email' name='mails' onFocus={lupin} required/><span id="zero-write3" className='seocho'></span></td></tr>
            <tr><th>추가사항</th><td className='myung'><textarea className='arey' name='story'/></td></tr> 
            <div className={kulli ? 'mapa' : 'manon'} onClick={pezi}>
               
            </div>
            <div className={kulli ? 'maho' : 'manon'} onClick={e=>e.stopPropagation()}>
                <p className='pee2' onClick={pezi}>X</p>
                <textarea className='kulji'></textarea>
                <span className='suuu'>글자수</span>
                <span className='beei'>비용</span>
                <p className='pee' onClick={pezi}>확인</p>
                </div>
        </tbody>
     </table>   
     <button onSubmit={kkk} value='sug2' name='buta' className='zongyo'>제출</button>
    </form>}

    {sna == 2 &&
<div>
    <div style={{marginBottom:"50px"}}>
    <span onClick={voki} name="pici" className='piroya' style={{marginRight:"10px"}}>PC</span>
    <span onClick={voki} name="mobip" className='piroya' style={{marginLeft:"10px"}}>Mobile</span>
</div>
<div className='banas'>
    <div className='banas1'>
        <img src={`${process.env.PUBLIC_URL}/pc-ad1.png`} />
    </div>
    <div className='banas2'>
        <div className='banas4'><p className='banaf quai'>돌파메인</p><p><span>PC & MOBILE</span><span className='won12'>일 8만원</span></p></div>    
        <div className='banas4'><p className='banaf quai'>돌파추천</p><p><span>PC & MOBILE</span><span className='won12'>일 6만원</span></p></div>
        <div className='banas4'><p className='banaf quai'>돌파스페셜</p><p><span>PC & MOBILE</span><span className='won12'>일 4만원</span></p></div>
        <div className='banas4'><p className='banaf quai'>돌파주목</p><p><span>PC & MOBILE</span><span className='won12'>일 3만원</span></p></div>
        <div className='banas4'><p className='banaf quai'>이벤트배너</p><p><span>PC & MOBILE</span><span className='won12'>일 3만원</span></p></div>
        <div className='banas4'><p className='banaf quai'>리스트탑</p><p><span>PC & MOBILE</span><span className='won12'>일 2.5만원</span></p></div>
        <div className='banas4'><p>패키지A</p><p><span>PC & MOBILE</span><span className='won12'>일 11만원</span></p>
        <p>돌파메인, 돌파추천, 리스트탑</p></div>
        <div className='banas4'><p>패키지B</p><p><span>PC & MOBILE</span><span className='won12'>일 9만원</span></p>
        <p>돌파메인, 돌파스페셜, 리스트탑</p></div>
        <div className='banas4'><p>패키지C</p><p><span>PC & MOBILE</span><span className='won12'>일 7만원</span></p>
        <p>돌파추천, 돌파주목, 리스트탑</p></div>
    </div>
</div>
<div className='banas maga'>
    <div className='banas1'>
        <img src={`${process.env.PUBLIC_URL}/mob-ad1.png`} />
    </div>
    <div className='banas2'>
        <div className='banas4'><p className='banaf quai'>돌파메인</p><p><span>PC & MOBILE</span><span className='won12'>일 8만원</span></p></div>    
        <div className='banas4'><p className='banaf quai'>돌파추천</p><p><span>PC & MOBILE</span><span className='won12'>일 6만원</span></p></div>
        <div className='banas4'><p className='banaf quai'>돌파스페셜</p><p><span>PC & MOBILE</span><span className='won12'>일 4만원</span></p></div>
        <div className='banas4'><p className='banaf quai'>돌파주목</p><p><span>PC & MOBILE</span><span className='won12'>일 3만원</span></p></div>
        <div className='banas4'><p className='banaf quai'>이벤트배너</p><p><span>PC & MOBILE</span><span className='won12'>일 3만원</span></p></div>
        <div className='banas4'><p className='banaf quai'>리스트탑</p><p><span>PC & MOBILE</span><span className='won12'>일 2.5만원</span></p></div>
        <div className='banas4'><p>패키지A</p><p><span>PC & MOBILE</span><span className='won12'>일 11만원</span></p>
        <p>돌파메인, 돌파추천, 리스트탑</p></div>
        <div className='banas4'><p>패키지B</p><p><span>PC & MOBILE</span><span className='won12'>일 9만원</span></p>
        <p>돌파메인, 돌파스페셜, 리스트탑</p></div>
        <div className='banas4'><p>패키지C</p><p><span>PC & MOBILE</span><span className='won12'>일 7만원</span></p>
        <p>돌파추천, 돌파주목, 리스트탑</p></div>
    </div>
</div>

<div className='banas3'>
    <p></p>
</div>
    
    </div>}
    </>
    );
};

export default Wonha;